
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparepeorates/contact-us",
      function () {
        return require("private-next-pages/comparepeorates/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparepeorates/contact-us"])
      });
    }
  